import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axios/axios.js";

export const GenerateCaptions = createAsyncThunk(
  "/api/v1/ai/generate-caption",  
  async (description) => {
    const response = await axios.post("/api/v1/ai/generate-caption", { description });
    return response.data; 
  }
);

const GenerateCaptionSlice = createSlice({
  name: "GenerateCaption",
  initialState: {
    captions: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GenerateCaptions.pending, (state) => {
        state.loading = true;
      })
      .addCase(GenerateCaptions.fulfilled, (state, action) => {
        state.loading = false;
        state.captions = action.payload;  
      })
      .addCase(GenerateCaptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default GenerateCaptionSlice.reducer;
